/**
 * Approximate coordinates for curated catalog activities.
 * Live provider inventory falls back to destination center + jitter.
 */
export const ACTIVITY_LOCATIONS = {
  // Bangkok
  'bkk-1': { lat: 13.75, lng: 100.4915, label: 'Grand Palace & Wat Pho' },
  'bkk-2': { lat: 13.7404, lng: 100.5101, label: 'Chinatown' },
  'bkk-3': { lat: 13.787, lng: 100.4564, label: 'Floating Market' },
  'bkk-4': { lat: 13.7215, lng: 100.517, label: 'Silom rooftop bars' },
  'bkk-5': { lat: 13.756, lng: 100.569, label: 'Lumpinee Muay Thai' },
  'bkk-6': { lat: 13.7467, lng: 100.4928, label: 'Wat Pho massage school' },
  'bkk-7': { lat: 13.7589, lng: 100.4974, label: 'Khao San Road' },
  'bkk-8': { lat: 13.746, lng: 100.534, label: 'Bangkok cooking school' },
  // Kyoto
  'kyoto-1': { lat: 35.0047, lng: 135.7689, label: 'Nishiki Market' },
  'kyoto-2': { lat: 34.9671, lng: 135.7727, label: 'Fushimi Inari' },
  'kyoto-3': { lat: 35.0037, lng: 135.7788, label: 'Gion tea ceremony' },
  'kyoto-4': { lat: 35.0036, lng: 135.7756, label: 'Gion district' },
  'kyoto-5': { lat: 34.9895, lng: 135.7598, label: 'Fushimi sake district' },
  'kyoto-6': { lat: 35.017, lng: 135.671, label: 'Arashiyama bamboo grove' },
  'kyoto-7': { lat: 35.0114, lng: 135.7945, label: 'Nanzen-ji temple' },
  'kyoto-8': { lat: 35.005, lng: 135.769, label: 'Pontocho alley' },
  // Lisbon
  'lisbon-1': { lat: 38.6976, lng: -9.2065, label: 'Belém' },
  'lisbon-2': { lat: 38.7125, lng: -9.1304, label: 'Alfama' },
  'lisbon-3': { lat: 38.797, lng: -9.388, label: 'Sintra' },
  'lisbon-4': { lat: 38.7167, lng: -9.133, label: 'Miradouro da Graça' },
  'lisbon-5': { lat: 38.7158, lng: -9.1365, label: 'Mouraria' },
  'lisbon-6': { lat: 38.7069, lng: -9.1456, label: 'Time Out Market' },
  'lisbon-7': { lat: 38.643, lng: -9.235, label: 'Costa da Caparica' },
  'lisbon-8': { lat: 38.7225, lng: -9.137, label: 'Intendente' },
  // Medellín
  'med-1': { lat: 6.247, lng: -75.622, label: 'Comuna 13' },
  'med-2': { lat: 6.15, lng: -75.65, label: 'Coffee region' },
  'med-3': { lat: 6.22, lng: -75.155, label: 'Guatapé' },
  'med-4': { lat: 6.208, lng: -75.567, label: 'El Poblado salsa' },
  'med-5': { lat: 6.251, lng: -75.564, label: 'Botero Plaza' },
  'med-6': { lat: 6.208, lng: -75.567, label: 'El Poblado' },
  'med-7': { lat: 6.244, lng: -75.598, label: 'San Felix paragliding' },
  'med-8': { lat: 6.255, lng: -75.59, label: 'Laureles' },
  // Florence
  'flo-1': { lat: 43.7677, lng: 11.2553, label: 'Uffizi Gallery' },
  'flo-2': { lat: 43.47, lng: 11.2, label: 'Chianti' },
  'flo-3': { lat: 43.7679, lng: 11.253, label: 'Ponte Vecchio' },
  'flo-4': { lat: 43.7696, lng: 11.2558, label: 'Florence center' },
  'flo-5': { lat: 43.773, lng: 11.256, label: 'Duomo' },
  'flo-6': { lat: 43.767, lng: 11.248, label: 'Oltrarno' },
  'flo-7': { lat: 43.765, lng: 11.248, label: 'Santo Spirito' },
  'flo-8': { lat: 43.7629, lng: 11.2658, label: 'Piazzale Michelangelo' },
  // Cape Town
  'ct-1': { lat: -33.9628, lng: 18.4098, label: 'Table Mountain' },
  'ct-2': { lat: -34.357, lng: 18.492, label: 'Cape Point' },
  'ct-3': { lat: -33.9215, lng: 18.4135, label: 'Bo-Kaap' },
  'ct-4': { lat: -33.9321, lng: 18.8602, label: 'Stellenbosch' },
  'ct-5': { lat: -34.622, lng: 19.314, label: 'Gansbaai' },
  'ct-6': { lat: -33.903, lng: 18.4205, label: 'V&A Waterfront' },
  'ct-7': { lat: -33.924, lng: 18.419, label: 'Long Street' },
  'ct-8': { lat: -33.95, lng: 18.67, label: 'Langa township' },
  // Barcelona
  'bcn-1': { lat: 41.4036, lng: 2.1744, label: 'Sagrada Família' },
  'bcn-2': { lat: 41.3816, lng: 2.1719, label: 'La Boqueria' },
  'bcn-3': { lat: 41.3834, lng: 2.1763, label: 'Gothic Quarter' },
  'bcn-4': { lat: 41.378, lng: 2.189, label: 'Barceloneta' },
  'bcn-5': { lat: 41.385, lng: 2.183, label: 'El Born' },
  'bcn-6': { lat: 41.387, lng: 2.174, label: 'Gothic Quarter tapas' },
  'bcn-7': { lat: 41.4145, lng: 2.1527, label: 'Park Güell' },
  'bcn-8': { lat: 41.381, lng: 2.167, label: 'El Raval' },
  // Reykjavik
  'ryk-1': { lat: 64.255, lng: -21.13, label: 'Golden Circle' },
  'ryk-2': { lat: 63.88, lng: -22.45, label: 'Blue Lagoon' },
  'ryk-3': { lat: 64.1466, lng: -21.9426, label: 'Reykjavik outskirts' },
  'ryk-4': { lat: 64.156, lng: -21.942, label: 'Old Harbour' },
  'ryk-5': { lat: 63.532, lng: -19.511, label: 'Sólheimajökull' },
  'ryk-6': { lat: 64.141, lng: -21.927, label: 'Hallgrímskirkja' },
  'ryk-7': { lat: 64.146, lng: -21.94, label: 'Reykjavik center' },
  'ryk-8': { lat: 64.255, lng: -21.116, label: 'Silfra fissure' },
  // Bali
  'bali-1': { lat: -8.431, lng: 115.279, label: 'Tegallalang terraces' },
  'bali-2': { lat: -8.518, lng: 115.259, label: 'Ubud Monkey Forest' },
  'bali-3': { lat: -8.506, lng: 115.262, label: 'Ubud cooking school' },
  'bali-4': { lat: -8.829, lng: 115.085, label: 'Uluwatu Temple' },
  'bali-5': { lat: -8.242, lng: 115.375, label: 'Mt. Batur' },
  'bali-6': { lat: -8.647, lng: 115.138, label: 'Canggu' },
  'bali-7': { lat: -8.506, lng: 115.262, label: 'Ubud yoga' },
  'bali-8': { lat: -8.691, lng: 115.168, label: 'Seminyak' },
  // Marrakech
  'mrk-1': { lat: 31.6258, lng: -7.9891, label: 'Jemaa el-Fnaa' },
  'mrk-2': { lat: 31.631, lng: -7.986, label: 'Medina souks' },
  'mrk-3': { lat: 31.6295, lng: -7.9811, label: 'Medina' },
  'mrk-4': { lat: 31.634, lng: -7.999, label: 'Hammam district' },
  'mrk-5': { lat: 31.133, lng: -7.917, label: 'Atlas Mountains' },
  'mrk-6': { lat: 31.6417, lng: -8.0033, label: 'Jardin Majorelle' },
  'mrk-7': { lat: 31.629, lng: -7.985, label: 'Medina rooftops' },
  'mrk-8': { lat: 31.099, lng: -4.012, label: 'Sahara gateway' },
  // New York
  'nyc-1': { lat: 40.7829, lng: -73.9654, label: 'Central Park' },
  'nyc-2': { lat: 40.6782, lng: -73.9442, label: 'Brooklyn' },
  'nyc-3': { lat: 40.748, lng: -74.0048, label: 'High Line' },
  'nyc-4': { lat: 40.759, lng: -73.985, label: 'Times Square' },
  'nyc-5': { lat: 40.7282, lng: -73.9942, label: 'Greenwich Village' },
  'nyc-6': { lat: 40.6892, lng: -74.0445, label: 'Statue of Liberty' },
  'nyc-7': { lat: 40.7536, lng: -73.9832, label: 'Bryant Park' },
  'nyc-8': { lat: 40.715, lng: -73.997, label: 'Chinatown' },
  // Paris
  'par-1': { lat: 48.8606, lng: 2.3376, label: 'Louvre' },
  'par-2': { lat: 48.8867, lng: 2.3431, label: 'Montmartre' },
  'par-3': { lat: 48.86, lng: 2.326, label: 'Seine river' },
  'par-4': { lat: 48.853, lng: 2.333, label: 'Saint-Germain' },
  'par-5': { lat: 48.8584, lng: 2.2945, label: 'Eiffel Tower' },
  'par-6': { lat: 48.857, lng: 2.362, label: 'Le Marais' },
  'par-7': { lat: 48.8462, lng: 2.3372, label: 'Luxembourg Gardens' },
  'par-8': { lat: 48.8049, lng: 2.1204, label: 'Versailles' },
  // Buenos Aires
  'ba-1': { lat: -34.621, lng: -58.371, label: 'San Telmo' },
  'ba-2': { lat: -34.6037, lng: -58.3816, label: 'Palermo' },
  'ba-3': { lat: -34.6345, lng: -58.3631, label: 'La Boca' },
  'ba-4': { lat: -34.5875, lng: -58.3932, label: 'Recoleta' },
  'ba-5': { lat: -34.587, lng: -58.425, label: 'Palermo Soho' },
  'ba-6': { lat: -34.6037, lng: -58.3816, label: 'Buenos Aires center' },
  'ba-7': { lat: -34.426, lng: -58.579, label: 'Tigre Delta' },
  'ba-8': { lat: -34.621, lng: -58.371, label: 'San Telmo milonga' },
  // Seoul
  'seoul-1': { lat: 37.5796, lng: 126.977, label: 'Gyeongbokgung' },
  'seoul-2': { lat: 37.5665, lng: 126.978, label: 'Gangnam BBQ' },
  'seoul-3': { lat: 37.5826, lng: 126.983, label: 'Bukchon Hanok' },
  'seoul-4': { lat: 37.5636, lng: 126.985, label: 'Myeongdong' },
  'seoul-5': { lat: 37.956, lng: 126.677, label: 'DMZ' },
  'seoul-6': { lat: 37.5563, lng: 126.9236, label: 'Hongdae' },
  'seoul-7': { lat: 37.5665, lng: 126.978, label: 'Seoul spa district' },
  'seoul-8': { lat: 37.5512, lng: 126.9882, label: 'Namsan Tower' },
  // Prague
  'prg-1': { lat: 50.09, lng: 14.399, label: 'Prague Castle' },
  'prg-2': { lat: 50.0755, lng: 14.4378, label: 'Old Town' },
  'prg-3': { lat: 50.0865, lng: 14.4114, label: 'Charles Bridge' },
  'prg-4': { lat: 50.087, lng: 14.421, label: 'Old Town Square' },
  'prg-5': { lat: 50.0755, lng: 14.4378, label: 'Prague center' },
  'prg-6': { lat: 50.08, lng: 14.45, label: 'Žižkov' },
  'prg-7': { lat: 50.0755, lng: 14.41, label: 'Vltava River' },
  'prg-8': { lat: 50.089, lng: 14.417, label: 'Jewish Quarter' },
};
